var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "8px",
    viewBox: "0 0 13 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05D7\u05E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D7\\u05E5",
    transform: "translate(-8.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "chevron-up-regular-(1)",
    transform: "translate(14.500000, 14.983333) rotate(-180.000000) translate(-14.500000, -14.983333) translate(8.700000, 11.600000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0920827747,6.14365488 L0.610722091,6.67274791 C0.733472928,6.79797292 0.932504269,6.79797292 1.0552813,6.67274791 L5.79999673,1.84388881 L10.5447383,6.67272119 C10.6674892,6.7979462 10.8665205,6.7979462 10.9892976,6.67272119 L11.5079369,6.14362816 C11.6306877,6.01840315 11.6306877,5.81536013 11.5079369,5.69010839 L6.02226323,0.0939187561 C5.8995124,-0.031306252 5.70048106,-0.031306252 5.57770402,0.0939187561 L0.0920827747,5.69013512 C-0.0306942582,5.81538685 -0.0306942582,6.01842987 0.0920827747,6.14365488 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6b6d49669bbad111305c8837df82c8b2.svg";
export { ForwardRef as ReactComponent };